module.exports = __webpack_public_path__ + "static/media/app-screens.d7b69bdc.png";